<svelte:options customElement={{ tag: "app-acl", shadow: "none" }} />
<script>
  import { onMount } from "svelte";

  export let aclAppId
  let app = null
  let users = {}
  $: allScopes = {}
  $: scopesByEmail = {}

  onMount(async () => {
    console.log("ACL Scopes")

    users = await window.api.authorization.users.query()
    const getScopes = await window.api.authorization.scopesByEmail.query({ appId: aclAppId })
    allScopes = getScopes.allScopes;
    scopesByEmail = getScopes.scopesByEmail;

    if(allScopes.length > 0) {
      app = allScopes[0].app
    }
  });

  async function modifyAuthScope(email, scope, granted) {
		const response = await window.api.admin.modifyAuthScopeForUser
			.mutate({ appId: aclAppId, email: email, scope: scope, granted: granted })

		if(response.success) {
			const getScopes = await window.api.authorization.scopesByEmail.query({ appId: aclAppId })
      allScopes = [ ...getScopes.allScopes ]
      scopesByEmail = { ...getScopes.scopesByEmail };
		}
	}
</script>

{#if app}
  <div class="container-xl">
    <div class="row">
      <h3>ACL scopes for {app.name}</h3>
      <div class="col-lg-6">
        {#each Object.entries(users) as [userIndex, user]}
          <div class="card" style="margin-bottom: 20px;">
            <div class="card-header">
              <h3 class="card-title">{user.email}</h3>
            </div>
            <div class="card-body">
              <div class="mb-3">
                <table>
                  <tbody>
                    {#each Object.entries(allScopes) as [index, scope]}
                      <tr>
                        <td>
                          {#if typeof scopesByEmail[user.email] !== 'undefined' 
                            && scopesByEmail[user.email].includes(scope.scope)
                          }
                            <input name="scopes[]" type="checkbox" id="{user.email}_{scope.scope}" 
                              class="form-check-input" value="{scope.scope}" 
                              on:click={() => modifyAuthScope(user.email, scope.scope, false)} checked/>
                          {:else}
                            <input name="scopes[]" type="checkbox" id="{user.email}_{scope.scope}" 
                              class="form-check-input" value="{scope.scope}" 
                              on:click={() => modifyAuthScope(user.email, scope.scope, true)}/>
                          {/if}
                        </td>
                        <td>
                          <label for="{user.email}_{scope.scope}">{scope.scope}</label>
                        </td>
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}